
import { ElementGridItem } from "../ElementGridItem";
import { supabase } from "@/integrations/supabase/client";
import { LayerImage } from "./types";

interface ElementsGridProps {
  images: LayerImage[];
  onImageClick: (image: LayerImage) => void;
  isAuthenticated: boolean;
}

const GridSkeleton = () => (
  <div className="grid grid-cols-2 gap-4">
    {[...Array(4)].map((_, i) => (
      <div 
        key={i} 
        className="aspect-square rounded-md bg-gray-100 animate-pulse"
      />
    ))}
  </div>
);

export function ElementsGrid({ images, onImageClick, isAuthenticated }: ElementsGridProps) {
  if (!images?.length) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No elements found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {images.map((image) => {
        const requiresLogin = !image.title.toLowerCase().includes('bilobed');
        const isPremium = requiresLogin && !isAuthenticated;

        return (
          <ElementGridItem
            key={image.id}
            title={image.title}
            imageSrc={supabase.storage.from('layer-images').getPublicUrl(image.image_path).data.publicUrl}
            isPremium={isPremium}
            onClick={() => onImageClick(image)}
            showTitleAlways={true}
          />
        );
      })}
    </div>
  );
}

export { GridSkeleton };
